// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"85":"09b62425","89":"4a17ded5","259":"02b3b70f","284":"b6671862","300":"fd6fcacf","415":"809fe3c2","453":"e8856a52","736":"5c1f1315"}[chunkId] + ".chunk.js";
};